import React, { useEffect, useState } from 'react';
import { Box, Typography, Badge } from '@mui/material';
import DashboardLayout from '../Sidebar/DashboardLayout';
import EmailIcon from '@mui/icons-material/Email';
import SettingsIcon from '@mui/icons-material/Settings';
import TuneIcon from '@mui/icons-material/Tune';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import BugReportIcon from '@mui/icons-material/BugReport';
import SecurityIcon from '@mui/icons-material/Security';
import PersonIcon from '@mui/icons-material/Person'
import { useNavigate } from 'react-router-dom';
import './administration.css';
import axios from 'axios';
import Chatbox from '../../commun/ChatBox';

const AdminPage = () => {
  const navigate = useNavigate();
  const [contactCount, setContactCount] = useState(0);
  const [permissions, setPermissions] = useState({});
  const userRole = localStorage.getItem('userType')?.toLowerCase();

  useEffect(() => {
    const fetchUnreadCount = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/contact-messages`);
        const unread = res.data.filter(msg => !msg.lu);
        setContactCount(unread.length);
      } catch {}
    };

    const fetchPermissions = async () => {
      if (userRole === 'admin') {
        const defaultPerms = {};
        cards.forEach(card => {
          if (card.permissionKey) {
            defaultPerms[card.permissionKey] = { Accès: true };
          }
        });
        setPermissions(defaultPerms);
      } else {
        try {
          const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/roles/${userRole}/permissions`);
          setPermissions(res.data || {});
        } catch {
          setPermissions({});
        }
      }
    };

    fetchUnreadCount();
    fetchPermissions();
  }, [userRole]);

  const cards = [
    {
  title: 'Statistiques Recruteurs',
  icon: <PersonIcon className="admin-card-icon" />,
  path: '/admin/statistiques-recruteurs',
  permissionKey: 'recruteurs-stats',
},
    {
      title: 'Demandes de contact',
      icon: (
        <Badge badgeContent={contactCount > 0 ? contactCount : null} color="error">
          <ContactMailIcon className="admin-card-icon" />
        </Badge>
      ),
      path: '/admin/contact-messages',
      permissionKey: 'contact-messages',
    },
    {
      title: 'Modèles d\'emails',
      icon: <EmailIcon className="admin-card-icon" />,
      path: '/admin/email-templates',
      permissionKey: 'email-templates',
    },
    {
      title: 'Rôles',
      icon: <SecurityIcon className="admin-card-icon" />,
      path: '/admin/roles',
      permissionKey: 'roles',
    },
      {
        title: 'Paramètres',
        icon: <SettingsIcon className="admin-card-icon" />,
        path: '/admin/parametres',
        permissionKey: 'settings',
      },

    {
      title: 'Autres',
      icon: <TuneIcon className="admin-card-icon" />,
      path: '/admin/others',
      permissionKey: 'others',
    },
    {
      title: 'Logs système',
      icon: <BugReportIcon className="admin-card-icon" />,
      path: '/admin/logs',
      permissionKey: 'logs',
    },
    
  ];

  const hasAccess = (menu) => {
    if (!menu) return true; 
    if (userRole === 'admin') return true;
    return permissions?.[menu]?.Accès === true;
  };

  return (
    <DashboardLayout>
      <Typography variant="h5" align="center" sx={{ mt: 4, mb: 2 }}>
        Administration
      </Typography>

      <Box className="admin-grid">
        {cards
          .filter(card => hasAccess(card.permissionKey))
          .map((card, index) => (
            <Box
              key={index}
              className="admin-card"
              onClick={() => navigate(card.path)}
              role="button"
            >
              {card.icon}
              <Typography variant="h6">{card.title}</Typography>
            </Box>
          ))}
      {userRole !== 'agent' && <Chatbox userRole={userRole} />}
      </Box>
    </DashboardLayout>
  );
};

export default AdminPage;
